import { render, staticRenderFns } from "./AllTipModal.vue?vue&type=template&id=f8666112&scoped=true"
import script from "./AllTipModal.vue?vue&type=script&lang=js"
export * from "./AllTipModal.vue?vue&type=script&lang=js"
import style0 from "./AllTipModal.vue?vue&type=style&index=0&id=f8666112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8666112",
  null
  
)

export default component.exports